import React, { useEffect } from "react";
import { FormControl, InputLabel, Button, InputAdornment, OutlinedInput, FormHelperText } from "@material-ui/core";
import { Add as AddIcon, Remove as RemoveIcon } from "@material-ui/icons";

// prop types
interface NumberPickerProps {
    disabled?: boolean,
    error?: boolean,
    helperText?: string,
    label?: string,
    max?: number,
    min?: number,
    step?: number,
    value: number,
    zeroPlaceholder?: string,
    onChange: (value: number) => void,
}

// number picker form element
const NumberPicker = ({ disabled, error, helperText, label, max, min, step, value, zeroPlaceholder, onChange }: NumberPickerProps) => {
    // change according to step
    const changeValue = (newValue: number) => {
        if (min !== undefined && newValue < min) {
            onChange(min);
        } else if (max !== undefined && newValue > max) {
            onChange(max);
        } else {
            onChange(Math.round(newValue / (step || 1)) * (step || 1)); // round to multiple of step
        }
    };

    // validate value on rules change
    useEffect(() => changeValue(value), [min, max, step]); // eslint-disable-line

    // render
    return (
        <FormControl disabled={disabled} error={error} fullWidth variant="outlined">
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
                endAdornment={(
                    <InputAdornment position="end">
                        <Button
                            disabled={disabled || ((max !== undefined) ? (value >= max) : false)}
                            onClick={() => changeValue(value + (step || 1))}
                        >
                            <AddIcon />
                        </Button>
                    </InputAdornment>
                )}
                inputProps={{ style: { textAlign: "center" } }}
                label={label}
                startAdornment={(
                    <InputAdornment position="start">
                        <Button
                            disabled={disabled || ((min !== undefined) ? (value <= min) : false)}
                            onClick={() => changeValue(value - (step || 1))}
                        >
                            <RemoveIcon />
                        </Button>
                    </InputAdornment>
                )}
                value={(value === 0 && zeroPlaceholder) ? zeroPlaceholder : value}
                onBlur={() => changeValue(value)}
                onChange={(e) => onChange(parseInt(e.target.value, 10) || value)}
            />
            {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default NumberPicker;
